var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observe, observable, action } from "mobx";
import { BetStatus } from "../enums";
export class Parser {
    constructor(retriever) {
        this.retriever = retriever;
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.selections = [];
        this.freeBets = [];
        this.isPlaceBetButtonEnabled = false;
        this.disposeBets = () => { };
        this.disposeErrors = () => { };
        this.disposePurchases = () => { };
        this.disposeSelections = () => { };
        this.disposeStatus = () => { };
        this.disposeStakeButtonsStatus = () => { };
        this.disposePlaceBetButtonState = () => { };
        this.disposeFreeBets = () => { };
        this.betStatus = BetStatus.Default;
        this.stakeButtonsStatus = this.retriever.stakeButtonsStatus;
    }
    activate() {
        this.disposeBets = observe(this.retriever, "bets", x => {
            this.parseToBets(x.newValue);
        });
        this.disposeErrors = observe(this.retriever, "errors", x => {
            this.parseToErrorModels(x.newValue);
        });
        this.disposePurchases = observe(this.retriever, "purchases", x => {
            this.parseToPurchaseModels(x.newValue);
        });
        this.disposeSelections = observe(this.retriever, "liveSelections", x => {
            this.parseToSelectionModels(x.newValue);
        });
        this.disposeSelections = observe(this.retriever, "preliveSelections", x => {
            this.parseToSelectionModels(x.newValue);
        });
        this.disposeFreeBets = observe(this.retriever, "freeBets", x => {
            this.parseToFreeBetsModels(x.newValue);
        });
        this.disposeStatus = observe(this.retriever, "betStatus", x => {
            this.parseStatus(x.newValue);
        });
        this.disposeStakeButtonsStatus = observe(this.retriever, "stakeButtonsStatus", x => {
            this.parseStakeButtonsStatus(x.newValue);
        });
        this.disposePlaceBetButtonState = observe(this.retriever, "isPlaceBetButtonEnabled", x => {
            this.setIsBetButtonEnabled(x.newValue);
        });
        this.retriever.activate();
    }
    deactivate() {
        this.retriever.deactivate();
        this.disposeBets();
        this.disposeStatus();
        this.disposeErrors();
        this.disposePurchases();
        this.disposeSelections();
        this.disposeFreeBets();
        this.disposeStakeButtonsStatus();
        this.disposePlaceBetButtonState();
        this.stakeButtonsStatus = Object.create({});
    }
    parseToErrorModels(updatedErrors) {
        this.errors = updatedErrors;
        return this.errors;
    }
    parseToPurchaseModels(updatedPurchases) {
        this.purchases = updatedPurchases;
        return this.purchases;
    }
    parseToFreeBetsModels(updatedSelections) {
        this.freeBets = updatedSelections;
        return this.freeBets;
    }
    parseToSelectionModels(updatedSelections) {
        this.selections = updatedSelections;
        return this.selections;
    }
    parseToBets(bets) {
        this.bets = bets;
        return this.bets;
    }
    parseStatus(updatedStatus) {
        this.betStatus = updatedStatus;
        return this.betStatus;
    }
    //added any as an option of updatedStatus type because jest doesn't covere it
    parseStakeButtonsStatus(updatedStatus) {
        this.stakeButtonsStatus = updatedStatus;
        return this.stakeButtonsStatus;
    }
    setIsBetButtonEnabled(value) {
        this.isPlaceBetButtonEnabled = value;
        return this.isPlaceBetButtonEnabled;
    }
    placeBet(stake, selections) {
        return this.retriever.placeBet(stake, selections);
    }
    selectFreeBet(selectFreeBetId) {
        return this.retriever.selectFreeBet(selectFreeBetId);
    }
    removeSelections(selections) {
        return this.retriever.removeSelectionsRequest(selections);
    }
    retainPurchase(purchaseId, purchaseViewKey) {
        return this.retriever.retainPurchaseRequest(purchaseId, purchaseViewKey);
    }
    clearPurchase(purchaseId, purchaseViewKey) {
        return this.retriever.clearPurchaseRequest(purchaseId, purchaseViewKey);
    }
    clearAllPurchases(purchases) {
        return this.retriever.clearAllPurchases(purchases);
    }
    updateNewOfferStatus(waitingBetId, isAccepted) {
        this.retriever.updateNewOfferStatus(waitingBetId, isAccepted);
    }
    updateOddsChangeStatus(isAccepted) {
        this.retriever.updateOddsChangeStatus(isAccepted);
    }
    changeStake(stake, buttonAction) {
        return this.retriever.changeStake(stake, buttonAction);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "bets", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "errors", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "purchases", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "selections", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "freeBets", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Parser.prototype, "isPlaceBetButtonEnabled", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "betStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "stakeButtonsStatus", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "deactivate", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseToErrorModels", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseToPurchaseModels", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseToFreeBetsModels", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseToSelectionModels", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseToBets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseStatus", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "parseStakeButtonsStatus", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "setIsBetButtonEnabled", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "retainPurchase", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "clearPurchase", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "clearAllPurchases", null);
//# sourceMappingURL=Parser.js.map